"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const utility_1 = require("../utility");
const getVehicleProfitHighlights = async ({ axios, vehicleId, currency, period, timezone = utility_1.getTimeZone() }) => {
    const { data } = await http_1.httpGet({
        axios,
        url: `vehicles/${vehicleId}/highlights/profit`,
        params: { timezone, currency, period }
    });
    return data;
};
exports.default = getVehicleProfitHighlights;
